import { CLEAN_REDUCER, GOOGLE_LOADED, LOADING_TRACE, UPDATE_DEVICE_EVENT } from '../constants/actionTypes';
import { LOG_OUT } from '../features/auth/actionTypes';

const initState = {
	googleLoaded: false,
	event: false,
	loadingTraceState: false,
};

const reducer = (state = initState, action) => {
	switch (action.type) {
		case UPDATE_DEVICE_EVENT:
			return { ...state, event: !state.event };
		case LOADING_TRACE:
			return {
				...state,
				loadingTraceState: !state.loadingTraceState,
			};
		case GOOGLE_LOADED:
			return {
				...state,
				googleLoaded: true,
				event: false,
			};
		case CLEAN_REDUCER:
		case LOG_OUT:
			return initState;
		default:
			return state;
	}
};

export default reducer;
